export default "__VITE_ASSET__1fa64843__"